import { Action, createReducer, on } from '@ngrx/store';
import { clearTrialGridRefresh, refreshTrialGrid, setTrialBundles, setTrialReservationInfo } from './trials.actions';
import { TrialsState } from './trials.model';

export const trialsInitialState: TrialsState = {
  bundles: [
    {
      id: '',
      name: '',
      description: '',
      credits: '',
      products: [],
    },
  ],
  refreshGrid: false,
};
const setTrialsData = createReducer(
  trialsInitialState,
  on(
    setTrialReservationInfo,
    (state: TrialsState, { payload }): TrialsState => ({
      ...state,
      reservation: payload,
    }),
  ),
  on(
    setTrialBundles,
    (state: TrialsState, { payload }): TrialsState => ({
      ...state,
      bundles: payload,
    }),
  ),
  on(
    refreshTrialGrid,
    (state: TrialsState): TrialsState => ({
      ...state,
      refreshGrid: true,
    }),
  ),
  on(
    clearTrialGridRefresh,
    (state: TrialsState): TrialsState => ({
      ...state,
      refreshGrid: false,
    }),
  ),
);

export function trialsReducer(state: TrialsState, action: Action): TrialsState {
  return setTrialsData(state, action);
}
